import React from 'react';
import { components } from 'react-select';

const NoOptionsMessage = ({ ...props }) => (
  <components.NoOptionsMessage {...props}>No results found</components.NoOptionsMessage>
);

export default NoOptionsMessage;
